import { AsideInfo } from '@components'

import { Flex, ModuleLayout, SkeletonBox, SkeletonText, Spacing } from '@billy/design-system'
import React, { ReactElement } from 'react'

import * as Styled from './styles'

const skeletonHeaderConfig = [{ width: 150 }, { width: 100 }, { width: 80 }]

const SkeletonSection = () => (
  <>
    <Styled.SectionRow />
    <table>
      <thead>
        <tr>
          {skeletonHeaderConfig.map((cell, idx) => (
            <Styled.HeadCell key={idx}>
              <SkeletonBox height={14} width={cell.width} />
            </Styled.HeadCell>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 4 }).map((_, index) => (
          <tr key={index}>
            <Styled.BodyCell>
              <SkeletonBox height={14} width={20} />
              <SkeletonBox height={14} width={140} />
            </Styled.BodyCell>
            <Styled.BodyCell>
              <SkeletonBox height={14} width={80} />
            </Styled.BodyCell>
            <Styled.BodyCell>
              <SkeletonBox height={14} width={60} />
            </Styled.BodyCell>
          </tr>
        ))}
      </tbody>
    </table>
  </>
)

export const VatDeclarationsLoadingView = (): ReactElement => {
  return (
    <ModuleLayout title={<SkeletonText variant="h1" width={200} />}>
      <Flex gap={Spacing.S32}>
        <Styled.ReportContentWrapper data-testid="vat-declarations-loading-view">
          <tbody>
            <tr>
              <td>
                <SkeletonSection />
                <SkeletonSection />
                <SkeletonSection />
              </td>
            </tr>
          </tbody>
        </Styled.ReportContentWrapper>
        <Styled.AsideWrapper>
          <AsideInfo>
            <SkeletonBox height={200} fullWidth />
          </AsideInfo>
        </Styled.AsideWrapper>
      </Flex>
    </ModuleLayout>
  )
}
